import { useEffect, useState } from 'react'
import { Loader2 } from 'lucide-react'
import { AppRouter } from './router'
import { bootstrapClientAuthOnce, useAuthStore } from '@/stores/auth-store'
import { initializeTheme } from '@/stores/ui-store'
import { supabase } from '@/lib/supabase'
import { Sonner } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'

function App() {
  const [authBootstrapDone, setAuthBootstrapDone] = useState(false)

  useEffect(() => {
    initializeTheme()

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event) => {
      if (
        event === 'INITIAL_SESSION' ||
        event === 'SIGNED_IN' ||
        event === 'TOKEN_REFRESHED' ||
        event === 'USER_UPDATED'
      ) {
        void useAuthStore.getState().fetchProfile()
      }
    })

    void bootstrapClientAuthOnce().finally(() => setAuthBootstrapDone(true))

    return () => subscription.unsubscribe()
  }, [])

  return (
    <TooltipProvider>
      {!authBootstrapDone ? (
        <div className="flex min-h-screen items-center justify-center bg-background">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" aria-hidden />
          <span className="sr-only">Loading session…</span>
        </div>
      ) : (
        <>
          <AppRouter />
          <Sonner />
        </>
      )}
    </TooltipProvider>
  )
}

export default App